import React, { Component } from 'react';
import PopularShow from './PopularShow';
import Image from './Image';
import { Link } from 'react-router-dom';
import Uri from 'jsuri';

export default class ResultEntry extends Component {
	constructor(props) {
		super(props);

		this.uri = new Uri(window.location.search);

		let urlNode = document.createElement('a');
		urlNode.setAttribute('href', props.url);
		let url_base = urlNode.hostname;

		this.state = {
			"name": props.name,
			"category": props.category,
			"assets": props.assets,
			"url": props.url,
			"url_base": url_base,
			"popularShows": props.popularShows,
			"query": props.query
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			"query": nextProps.query,
		});
	}

	render() {
		let popularShows = [];
		let i = 0;
		this.state.popularShows.forEach((popularShow) => {
			if(popularShow != null) {
				popularShows.push(
					<PopularShow key={i} popularShow={popularShow} />
				);
				i++;
			}
		});

		this.categoryLink = this.uri.clone().replaceQueryParam('q', this.state.category).toString();

		return [
			<li key="0">
				<span className="item">
					<a href={this.state.url} target="_blank">
						<Image assets={this.state.assets} name={this.state.name} />
					</a>
					<Link to={this.categoryLink} className="category">
						{this.state.category}
					</Link>
					<span className="details">
						<a href={this.state.url} target="_blank"><small>{this.state.url_base}</small></a>
						<span className="popularShows">
							{popularShows}
						</span>
						<a href={this.state.url} target="_blank" className="cta">Zum Live Stream <svg x="0px" y="0px" viewBox="0 0 200 200"><path d="M100,1C45.4,1,1,45.4,1,100s44.4,99,99,99s99-44.4,99-99S154.6,1,100,1z M145.4,107.1l-66,38.6c-1.3,0.9-2.8,1.1-4.1,1.1 c-1.3,0-2.8-0.2-4.1-1.1c-2.6-1.3-4.1-4.1-4.1-7.1V61.4c0-3,1.7-5.8,4.1-7.1c2.6-1.3,5.8-1.3,8.1,0l66,38.6c2.6,1.3,4.1,4.1,4.1,7.1 S147.8,105.8,145.4,107.1z"/></svg></a>
					</span>
				</span>
			</li>
		];
	}
}


// WEBPACK FOOTER //
// ./src/ResultEntry.js